export default [
  {
    path: "/info/atmmodel",
    name: "atmmodel",
    component: () => import("@/views/info/atmmodel/index.vue"),
    meta: {
      pageTitle: "AtmModel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmmodel/edit/id=:id",
    name: "EditAtmModel",
    component: () => import("@/views/info/atmmodel/edit.vue"),
    meta: {
      pageTitle: "AtmModel",
      navActiveLink: "atmmodel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/banknoteversion",
    name: "banknoteversion",
    component: () => import("@/views/info/banknoteversion/index.vue"),
    meta: {
      pageTitle: "BanknoteVersion",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BanknoteVersion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/banknoteversion/edit/id=:id",
    name: "EditBanknoteVersion",
    component: () => import("@/views/info/banknoteversion/edit.vue"),
    meta: {
      pageTitle: "BanknoteVersion",
      navActiveLink: "banknoteversion",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BanknoteVersion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/sealer",
    name: "sealer",
    component: () => import("@/views/info/sealer/index.vue"),
    meta: {
      pageTitle: "Sealer",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Sealer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/sealer/edit/id=:id",
    name: "EditSealer",
    component: () => import("@/views/info/sealer/edit.vue"),
    meta: {
      pageTitle: "Sealer",
      navActiveLink: "sealer",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Sealer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/keychain",
    name: "keychain",
    component: () => import("@/views/info/keychain/index.vue"),
    meta: {
      pageTitle: "KeyChain",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "KeyChain",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/keychain/edit/id=:id",
    name: "EditKeyChain",
    component: () => import("@/views/info/keychain/edit.vue"),
    meta: {
      pageTitle: "KeyChain",
      navActiveLink: "keychain",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "KeyChain",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/setofkey",
    name: "setofkey",
    component: () => import("@/views/info/setofkey/index.vue"),
    meta: {
      pageTitle: "SetOfKey",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SetOfKey",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/setofkey/edit/id=:id",
    name: "EditSetOfKey",
    component: () => import("@/views/info/setofkey/edit.vue"),
    meta: {
      pageTitle: "SetOfKey",
      navActiveLink: "setofkey",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SetOfKey",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bagbsc",
    name: "bagbsc",
    component: () => import("@/views/info/bagbsc/index.vue"),
    meta: {
      pageTitle: "BagBsc",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BagBsc",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bagbsc/edit/id=:id",
    name: "EditBagBsc",
    component: () => import("@/views/info/bagbsc/edit.vue"),
    meta: {
      pageTitle: "BagBsc",
      navActiveLink: "bagbsc",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BagBsc",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicatmallowtransactionconfig",
    name: "republicatmallowtransactionconfig",
    component: () => import("@/views/info/republicatmallowtransactionconfig/index.vue"),
    meta: {
      pageTitle: "RepublicAtmAllowTransactionConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicAtmAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicatmallowtransactionconfig/edit/id=:id",
    name: "EditRepublicAtmAllowTransactionConfig",
    component: () => import("@/views/info/republicatmallowtransactionconfig/edit.vue"),
    meta: {
      pageTitle: "RepublicAtmAllowTransactionConfig",
      navActiveLink: "republicatmallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicAtmAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republicatmallowtransactionconfig/view/id=:id",
    name: "ViewRepublicAtmAllowTransactionConfig",
    component: () => import("@/views/info/republicatmallowtransactionconfig/view.vue"),
    meta: {
      pageTitle: "RepublicAtmAllowTransactionConfig",
      navActiveLink: "republicatmallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicAtmAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmbranchsettlementaccountconfig",
    name: "atmbranchsettlementaccountconfig",
    component: () => import("@/views/info/atmbranchsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "AtmBranchSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmBranchSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmbranchsettlementaccountconfig/edit/id=:id",
    name: "EditAtmBranchSettlementAccountConfig",
    component: () => import("@/views/info/atmbranchsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "AtmBranchSettlementAccountConfig",
      navActiveLink: "atmbranchsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmBranchSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmsettlementaccountconfig",
    name: "atmsettlementaccountconfig",
    component: () => import("@/views/info/atmsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "AtmSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmsettlementaccountconfig/edit/id=:id",
    name: "EditAtmSettlementAccountConfig",
    component: () => import("@/views/info/atmsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "AtmSettlementAccountConfig",
      navActiveLink: "atmsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmsettlementaccountconfig/view/id=:id",
    name: "ViewAtmSettlementAccountConfig",
    component: () => import("@/views/info/atmsettlementaccountconfig/view.vue"),
    meta: {
      pageTitle: "AtmSettlementAccountConfig",
      navActiveLink: "atmsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmdevicepart",
    name: "atmdevicepart",
    component: () => import("@/views/info/atmdevicepart/index.vue"),
    meta: {
      pageTitle: "AtmDevicePart",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmDevicePart",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmdevicepart/edit/id=:id",
    name: "EditAtmDevicePart",
    component: () => import("@/views/info/atmdevicepart/edit.vue"),
    meta: {
      pageTitle: "AtmDevicePart",
      navActiveLink: "atmdevicepart",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmDevicePart",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transportmodel",
    name: "transportmodel",
    component: () => import("@/views/info/transportmodel/index.vue"),
    meta: {
      pageTitle: "TransportModel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransportModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transportmodel/edit/id=:id",
    name: "EditTransportModel",
    component: () => import("@/views/info/transportmodel/edit.vue"),
    meta: {
      pageTitle: "TransportModel",
      navActiveLink: "transportmodel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransportModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transporttype",
    name: "transporttype",
    component: () => import("@/views/info/transporttype/index.vue"),
    meta: {
      pageTitle: "TransportType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransportType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transporttype/edit/id=:id",
    name: "EditTransportType",
    component: () => import("@/views/info/transporttype/edit.vue"),
    meta: {
      pageTitle: "TransportType",
      navActiveLink: "transporttype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransportType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/specialgroupmembertype",
    name: "specialgroupmembertype",
    component: () => import("@/views/info/specialgroupmembertype/index.vue"),
    meta: {
      pageTitle: "SpecialGroupMemberType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SpecialGroupMemberType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/specialgroupmembertype/edit/id=:id",
    name: "EditSpecialGroupMemberType",
    component: () => import("@/views/info/specialgroupmembertype/edit.vue"),
    meta: {
      pageTitle: "SpecialGroupMemberType",
      navActiveLink: "specialgroupmembertype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SpecialGroupMemberType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/recountdevicemodel",
    name: "recountdevicemodel",
    component: () => import("@/views/info/recountdevicemodel/index.vue"),
    meta: {
      pageTitle: "RecountDeviceModel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RecountDeviceModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/recountdevicemodel/edit/id=:id",
    name: "EditRecountDeviceModel",
    component: () => import("@/views/info/recountdevicemodel/edit.vue"),
    meta: {
      pageTitle: "RecountDeviceModel",
      navActiveLink: "recountdevicemodel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RecountDeviceModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/recountdevice",
    name: "recountdevice",
    component: () => import("@/views/info/recountdevice/index.vue"),
    meta: {
      pageTitle: "RecountDevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RecountDevice",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/recountdevice/edit/id=:id",
    name: "EditRecountDevice",
    component: () => import("@/views/info/recountdevice/edit.vue"),
    meta: {
      pageTitle: "RecountDevice",
      navActiveLink: "recountdevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RecountDevice",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/driver",
    name: "driver",
    component: () => import("@/views/info/driver/index.vue"),
    meta: {
      pageTitle: "Driver",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Driver",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/driver/edit/id=:id",
    name: "EditDriver",
    component: () => import("@/views/info/driver/edit.vue"),
    meta: {
      pageTitle: "Driver",
      navActiveLink: "driver",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Driver",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transport",
    name: "transport",
    component: () => import("@/views/info/transport/index.vue"),
    meta: {
      pageTitle: "Transport",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transport/edit/id=:id",
    name: "EditTransport",
    component: () => import("@/views/info/transport/edit.vue"),
    meta: {
      pageTitle: "Transport",
      navActiveLink: "transport",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Transport",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/devicemodel",
    name: "devicemodel",
    component: () => import("@/views/info/devicemodel/index.vue"),
    meta: {
      pageTitle: "DeviceModel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DeviceModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/devicemodel/edit/id=:id",
    name: "EditDeviceModel",
    component: () => import("@/views/info/devicemodel/edit.vue"),
    meta: {
      pageTitle: "DeviceModel",
      navActiveLink: "devicemodel",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DeviceModel",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/systemdevice",
    name: "systemdevice",
    component: () => import("@/views/info/systemdevice/index.vue"),
    meta: {
      pageTitle: "SystemDevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SystemDevice",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/systemdevice/edit/id=:id",
    name: "EditSystemDevice",
    component: () => import("@/views/info/systemdevice/edit.vue"),
    meta: {
      pageTitle: "SystemDevice",
      navActiveLink: "systemdevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SystemDevice",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bagnmd",
    name: "bagnmd",
    component: () => import("@/views/info/bagnmd/index.vue"),
    meta: {
      pageTitle: "BagNmd",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BagNmd",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bagnmd/edit/id=:id",
    name: "EditBagNmd",
    component: () => import("@/views/info/bagnmd/edit.vue"),
    meta: {
      pageTitle: "BagNmd",
      navActiveLink: "bagnmd",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BagNmd",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmreasonoffline",
    name: "atmreasonoffline",
    component: () => import("@/views/info/atmreasonoffline/index.vue"),
    meta: {
      pageTitle: "AtmReasonOffline",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmReasonOffline",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmreasonoffline/edit/id=:id",
    name: "EditAtmReasonOffline",
    component: () => import("@/views/info/atmreasonoffline/edit.vue"),
    meta: {
      pageTitle: "AtmReasonOffline",
      navActiveLink: "atmreasonoffline",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmReasonOffline",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techsupportservice",
    name: "techsupportservice",
    component: () => import("@/views/info/techsupportservice/index.vue"),
    meta: {
      pageTitle: "TechSupportService",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechSupportService",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techsupportservice/edit/id=:id",
    name: "EditTechSupportService",
    component: () => import("@/views/info/techsupportservice/edit.vue"),
    meta: {
      pageTitle: "TechSupportService",
      navActiveLink: "techsupportservice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechSupportService",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techinspectionresult",
    name: "techinspectionresult",
    component: () => import("@/views/info/techinspectionresult/index.vue"),
    meta: {
      pageTitle: "TechInspectionResult",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechInspectionResult",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techinspectionresult/edit/id=:id",
    name: "EditTechInspectionResult",
    component: () => import("@/views/info/techinspectionresult/edit.vue"),
    meta: {
      pageTitle: "TechInspectionResult",
      navActiveLink: "techinspectionresult",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechInspectionResult",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techmessage",
    name: "techmessage",
    component: () => import("@/views/info/techmessage/index.vue"),
    meta: {
      pageTitle: "TechMessage",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechMessage",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/techmessage/edit/id=:id",
    name: "EditTechMessage",
    component: () => import("@/views/info/techmessage/edit.vue"),
    meta: {
      pageTitle: "TechMessage",
      navActiveLink: "techmessage",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TechMessage",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/geolocationhint",
    name: "geolocationhint",
    component: () => import("@/views/info/geolocationhint/index.vue"),
    meta: {
      pageTitle: "GeoLocationHint",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "GeoLocationHint",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/geolocationhint/edit/id=:id",
    name: "EditGeoLocationHint",
    component: () => import("@/views/info/geolocationhint/edit.vue"),
    meta: {
      pageTitle: "GeoLocationHint",
      navActiveLink: "geolocationhint",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "GeoLocationHint",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/holiday",
    name: "holiday",
    component: () => import("@/views/info/holiday/index.vue"),
    meta: {
      pageTitle: "Holiday",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Holiday",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/holiday/edit/id=:id",
    name: "EditHoliday",
    component: () => import("@/views/info/holiday/edit.vue"),
    meta: {
      pageTitle: "Holiday",
      navActiveLink: "holiday",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Holiday",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/smstext",
    name: "smstext",
    component: () => import("@/views/info/smstext/index.vue"),
    meta: {
      pageTitle: "SmsText",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SmsText",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/smstext/edit/id=:id",
    name: "EditSmsText",
    component: () => import("@/views/info/smstext/edit.vue"),
    meta: {
      pageTitle: "SmsText",
      navActiveLink: "smstext",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SmsText",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmservicezone",
    name: "atmservicezone",
    component: () => import("@/views/info/atmservicezone/index.vue"),
    meta: {
      pageTitle: "AtmServiceZone",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmServiceZone",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmservicezone/edit/id=:id",
    name: "EditAtmServiceZone",
    component: () => import("@/views/info/atmservicezone/edit.vue"),
    meta: {
      pageTitle: "AtmServiceZone",
      navActiveLink: "atmservicezone",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmServiceZone",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bscservicezone",
    name: "bscservicezone",
    component: () => import("@/views/info/bscservicezone/index.vue"),
    meta: {
      pageTitle: "BscServiceZone",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BscServiceZone",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bscservicezone/edit/id=:id",
    name: "EditBscServiceZone",
    component: () => import("@/views/info/bscservicezone/edit.vue"),
    meta: {
      pageTitle: "BscServiceZone",
      navActiveLink: "bscservicezone",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BscServiceZone",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/calendar",
    name: "calendar",
    component: () => import("@/views/info/calendar/index.vue"),
    meta: {
      pageTitle: "Calendar",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Calendar",
          active: true,
        },
      ],
    },
  },
]
